import DTO from './DTO';

class StopsDTO extends DTO {
  stop_id;

  name;

  last_reported;

  location;

  status;

  capacity;

  num_vehicles_available;

  num_vehicles_disabled;

  geography_id;

  short_name;

  address;

  post_code;

  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'stop_id',
        type: String,
        validators: [],
        labelKey: 'stop_id',
      },
      {
        name: 'name',
        type: String,
        validators: [],
        labelKey: 'stop.name',
      },
      {
        name: 'last_reported',
        type: String,
        validators: [],
        labelKey: 'stop.last_reported',
      },
      {
        name: 'location',
        type: Object,
        validators: [],
        labelKey: 'stop.location',
      },
      {
        name: 'status',
        type: Object,
        validators: [],
        labelKey: 'stop.status',
      },
      {
        name: 'capacity',
        type: Object,
        validators: [],
        labelKey: 'stop.capacity',
      },
      {
        name: 'num_vehicles_available',
        type: Object,
        validators: [],
        labelKey: 'stop.num_vehicles_available',
      },
      {
        name: 'num_vehicles_disabled',
        type: Object,
        validators: [],
        labelKey: 'stop.num_vehicles_disabled',
      },
      {
        name: 'geography_id',
        type: String,
        validators: [],
        labelKey: 'stop.geography_id',
      },
      {
        name: 'short_name',
        type: String,
        validators: [],
        labelKey: 'stop.short_name',
      },
      {
        name: 'address',
        type: String,
        validators: [],
        labelKey: 'stop.address',
      },
      {
        name: 'post_code',
        type: String,
        validators: [],
        labelKey: 'stop.post_code',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    const data = {
      stop_id: this.stop_id,
      name: this.name,
      last_reported: this.last_reported,
      location: this.location,
      status: {
        is_installed: false,
        is_renting: false,
        is_returning: false,
      },
      capacity: this.capacity,
      num_vehicles_available: this.num_vehicles_available,
      num_vehicles_disabled: this.num_vehicles_disabled,
      short_name: this.short_name,
      address: this.address,
      post_code: this.post_code,
    };
    if (this.geography_id) {
      data.geography_id = this.geography_id;
    }
    return data;
  }
}

export default StopsDTO;
